import { apiRequestActions } from 'utils/api-request-actions';
import { ApiRequestActionType } from 'types/action';

export const API_REQUEST = 'API_REQUEST';
export const FETCH_COMPANY_TYPES: ApiRequestActionType = apiRequestActions('FETCH_COMPANY_TYPES');
export const GET_CURRENT_CONTRACT: ApiRequestActionType = apiRequestActions('GET_CURRENT_CONTRACT');
export const GET_PACKAGE_PRICES: ApiRequestActionType = apiRequestActions('GET_PACKAGE_PRICES');
export const CREATE_SUBSCRIPTION_REQUEST: ApiRequestActionType = apiRequestActions(
  'CREATE_SUBSCRIPTION_REQUEST'
);
export const UPDATE_SUBSCRIPTION_MEMBER_DETAILS: ApiRequestActionType = apiRequestActions(
  'UPDATE_SUBSCRIPTION_MEMBER_DETAILS'
);
export const CONTACT_ME_REQUEST: ApiRequestActionType = apiRequestActions('CONTACT_ME_REQUEST');
export const LAST_SUBSCRIPTION_REQUEST: ApiRequestActionType = apiRequestActions(
  'LAST_SUBSCRIPTION_REQUEST'
);
export const FETCH_PAYMENT_STATUS: ApiRequestActionType = apiRequestActions('FETCH_PAYMENT_STATUS');
export const CREATE_CUSTOMER_AND_SETUP_INTENT: ApiRequestActionType = apiRequestActions(
  'CREATE_CUSTOMER_AND_SETUP_INTENT'
);
export const ATTACH_PAYMENT_METHOD: ApiRequestActionType =
  apiRequestActions('ATTACH_PAYMENT_METHOD');
export const MAKE_PAYMENT: ApiRequestActionType = apiRequestActions('MAKE_PAYMENT');
export const GET_PRICE_LIST_PAY_URL: ApiRequestActionType =
  apiRequestActions('GET_PRICE_LIST_PAY_URL');
export const RESET_PRICE_LIST_PAY_URL = 'RESET_PRICE_LIST_PAY_URL';
export const UPDATE_NEWS_LETTERS: ApiRequestActionType = apiRequestActions('UPDATE_NEWS_LETTERS');
export const FETCH_PAYMENT_LINK: ApiRequestActionType = apiRequestActions('FETCH_PAYMENT_LINK');
export const UPDATE_REGISTRATION_ID_FROM_CACHE = 'UPDATE_REGISTRATION_ID_FROM_CACHE';
export const RESET_ERROR = 'RESET_ERROR';
export const PROMO_CODE_DISCOUNT: ApiRequestActionType = apiRequestActions('PROMO_CODE_DISCOUNT');
